
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/ultimos",
      function () {
        return require("private-next-pages/podcast/ultimos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast/ultimos"])
      });
    }
  